import { useSettings } from '../settings/SettingsContext';
import PlayroomHome from '../designs/playroom/PlayroomHome';
import ExpeditionHome from '../designs/expedition/ExpeditionHome';
import GardenHome from '../designs/garden/GardenHome';
import PopupHome from '../designs/popup/PopupHome';
import BlocksHome from '../designs/blocks/BlocksHome';
import ClassicHome from './home/ClassicHome';
import { HomeDialogs } from './home/shared';
import { useHome } from './home/useHome';
import PreferencePrompt from '../preferences/PreferencePrompt';

const HOMES = {
  playroom: PlayroomHome,
  expedition: ExpeditionHome,
  garden: GardenHome,
  popup: PopupHome,
  blocks: BlocksHome,
} as const;

export default function HomePage() {
  const h = useHome();
  const { settings } = useSettings();
  const Home = HOMES[settings.design as keyof typeof HOMES] ?? ClassicHome;
  return (
    <>
      <PreferencePrompt />
      <Home h={h} />
      <HomeDialogs h={h} />
    </>
  );
}
